import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarComponent } from './calendar.component';
import { CalendarContainerComponent } from './components/calendar-container/calendar-container.component';

const routes: Routes = [
  {
    path: '',
    component: CalendarComponent,
    data: { breadcrumb: { label: 'Calendar View' } },
    children: [
      {
        path: '',
        component: CalendarContainerComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CalendarRoutingModule {}
